import { createFileRoute } from "@tanstack/react-router";
import { Mail } from "lucide-react";
import { PageHeader } from "@/components/page-header";
import { NewClientDialog } from "@/components/forms/new-client-dialog";
import { clients, fmtUsd } from "@/mocks/data";

export const Route = createFileRoute("/clients")({
  head: () => ({
    meta: [
      { title: "Clients — Studio OS" },
      { name: "description", content: "Client directory with lifetime value and shoot history." },
    ],
  }),
  component: ClientsPage,
});

function ClientsPage() {
  return (
    <div className="mx-auto max-w-7xl px-6 py-8 lg:px-10 lg:py-10">
      <PageHeader
        title="Clients"
        description={`${clients.length} contacts, total lifetime value ${fmtUsd(
          clients.reduce((s, c) => s + c.lifetimeValue, 0),
          { compact: true },
        )}.`}
        actions={<NewClientDialog />}
      />
      <div className="overflow-hidden rounded-xl bg-card ring-1 ring-border">
        <table className="w-full text-left text-sm">
          <thead className="border-b border-border bg-surface-muted/50">
            <tr className="text-[11px] uppercase tracking-wider text-muted-foreground">
              <th className="px-4 py-3 font-medium">Name</th>
              <th className="px-4 py-3 font-medium">Company</th>
              <th className="px-4 py-3 font-medium">Type</th>
              <th className="px-4 py-3 font-medium">Shoots</th>
              <th className="px-4 py-3 font-medium">Since</th>
              <th className="px-4 py-3 text-right font-medium">Lifetime</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-border">
            {clients.map((c) => (
              <tr key={c.id} className="transition hover:bg-surface-muted/40">
                <td className="px-4 py-3">
                  <div className="flex items-center gap-3">
                    <div className="flex size-8 flex-none items-center justify-center rounded-full bg-surface-muted font-mono text-[10px] font-medium ring-1 ring-border">
                      {c.name.split(" ").map((n) => n[0]).slice(0, 2).join("")}
                    </div>
                    <div className="leading-tight">
                      <p className="font-medium">{c.name}</p>
                      <p className="flex items-center gap-1 text-[11px] text-muted-foreground">
                        <Mail className="size-3" />
                        {c.email}
                      </p>
                    </div>
                  </div>
                </td>
                <td className="px-4 py-3 text-muted-foreground">{c.company ?? "—"}</td>
                <td className="px-4 py-3">
                  <span className="rounded-full bg-surface-muted px-2 py-0.5 text-[10px] font-medium uppercase tracking-wider text-muted-foreground ring-1 ring-inset ring-border">
                    {c.type}
                  </span>
                </td>
                <td className="px-4 py-3 font-mono text-muted-foreground">{c.shoots}</td>
                <td className="px-4 py-3 font-mono text-xs text-muted-foreground">{c.since}</td>
                <td className="px-4 py-3 text-right font-mono font-medium">{fmtUsd(c.lifetimeValue)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
